import { useEffect } from 'react';

interface SeoProps {
	title: string;
	description: string;
	path: string;
	noindex?: boolean;
}

export const CANONICAL_ORIGIN = 'https://pulsefit.cz';

const upsertMeta = (attr: 'name' | 'property', key: string, content: string) => {
	let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
	if (!tag) {
		tag = document.createElement('meta');
		tag.setAttribute(attr, key);
		document.head.appendChild(tag);
	}
	tag.setAttribute('content', content);
};

const upsertCanonical = (href: string) => {
	let tag = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
	if (!tag) {
		tag = document.createElement('link');
		tag.setAttribute('rel', 'canonical');
		document.head.appendChild(tag);
	}
	tag.setAttribute('href', href);
};

const removeCanonical = () => {
	document.querySelector('link[rel="canonical"]')?.remove();
};

export const Seo = ({ title, description, path, noindex }: SeoProps) => {
	useEffect(() => {
		const fullTitle = `${title} | PulseFit`;
		const url = `${CANONICAL_ORIGIN}${path}`;

		document.title = fullTitle;
		upsertMeta('name', 'description', description);
		upsertMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');

		// The static tags in index.html are the crawler/no-JS baseline; keep the
		// per-route social preview in sync for scrapers that do run the app.
		upsertMeta('property', 'og:title', fullTitle);
		upsertMeta('property', 'og:description', description);
		upsertMeta('property', 'og:url', url);
		upsertMeta('name', 'twitter:title', fullTitle);
		upsertMeta('name', 'twitter:description', description);

		if (noindex) {
			removeCanonical();
		} else {
			upsertCanonical(url);
		}
	}, [title, description, path, noindex]);

	return null;
};
